"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M16.09 11.65A5.462 5.462 0 0018 7.5C18 4.47 15.53 2 12.5 2H5v20h8.5c3.03 0 5.5-2.47 5.5-5.5 0-2.09-1.18-3.92-2.91-4.85zM8 4h3.5C13.43 4 15 5.57 15 7.5S13.43 11 11.5 11H8V4zm4.5 16H8v-7h4.5c1.93 0 3.5 1.57 3.5 3.5S14.43 20 12.5 20z" }), "Bold");
//# sourceMappingURL=Bold.js.map